



























import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import Axios from 'axios'
import { Playlist } from '@/classes/playlist'
import { USAGE_STAT_FEATURES } from '../../../../../system/usage-stats'

@Component({
  components: {
    BaseAction: require('./_Base').default
  }
})
export default class Create extends Vue {
  @Prop()
  selectedPlaylists: Playlist[]

  name: string = ''
  position: 'above' | 'below' = 'below'

  get selectedPlaylist(): Playlist | null {
    return this.selectedPlaylists.length === 1 ? this.selectedPlaylists[0] : null
  }

  get validation(): { message?: string, valid: boolean } {
    if (this.selectedPlaylists.length === 0) return { message: 'Please select the playlist you want to copy', valid: false }
    if (this.selectedPlaylists.length > 1) return { message: 'Please select only one playlist', valid: false }
    if (!this.name) return { message: 'Please enter a playlist name', valid: false }

    return { valid: true }
  }

  async save() {
    if (!this.validation.valid || !this.selectedPlaylist) return

    window.addUsageStat(USAGE_STAT_FEATURES.ManagePlaylist, 'copy', 'confirm', {
      position: this.position
    })

    return Axios.post('/playlist/copy', { // TODO: target and multiple support
      name: this.name,
      position: this.position,
      positionAnchorId: this.selectedPlaylist._id
    }).then((res) => {
      this.$buefy.notification.open('Copied playlist' + (this.selectedPlaylists.length === 1 ? '' : 's'))

      return res
    })
  }

  mounted() {
    (this.$refs as any).name.focus()
  }

  @Watch('selectedPlaylists', { immediate: true })
  watchSelectedPlaylists() {
    if (this.selectedPlaylist) {
      this.name = this.selectedPlaylist.name + ' Copy'
    } else {
      this.name = ''
    }
  }
}
